// extracted by mini-css-extract-plugin
export default {"collapseModal":"collapseModal_collapseModal__+w0R+","header":"collapseModal_header__yq-g0","icon":"collapseModal_icon__7xoki","content":"collapseModal_content__e7LFy"};